var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.slideStyle}},[(_vm.showStatus)?_c('city-view',{attrs:{"hide":_vm.hide,"backStyle":_vm.backStyle,"canSearchSpell":_vm.canSearchSpell},on:{"closeChooseCity":_vm.closeChooseCity}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-445e4c53","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/packages/BestCity.vue
// module id = 58
// module chunks = 0